import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { AppBundle } from 'api/optimalprint-sdk.d';
import setBundleProductByProductIdAndCategoryOperation from 'store/product/operation/setBundleProductByProductIdAndCategoryOperation';
import getFrameUpsellFrameTitle from 'store/product/selector/getFrameUpsellFrameTitle';
import getFrameUpsellFrameProductId from 'store/product/selector/getFrameUpsellFrameProductId';
import getFrameUpsellData from 'store/product/selector/getFrameUpsellData';
import getCategoryId from 'store/category/selector/getCategoryId';
import { setFrameUpsellSelectedFrameAction } from 'store/product/slice';
import ProductCarousel from 'components/Common/ProductCarousel/ProductCarousel';
import styles from './FrameSelector.module.scss';

const FrameSelector = () => {
  const dispatch = useDispatch();
  const frames = useSelector(getFrameUpsellData)?.items || [];
  const activeFrameProductId = useSelector(getFrameUpsellFrameProductId);
  const frameTitle = useSelector(getFrameUpsellFrameTitle);
  const categoryId = useSelector(getCategoryId);

  const selectFrame = (
    frame: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem,
    frameIndex: number,
  ) => {
    dispatch(setFrameUpsellSelectedFrameAction(frameIndex));
    dispatch(setBundleProductByProductIdAndCategoryOperation(Number(frame.categoryId || categoryId), frame.productId));
  };

  // preselect first frame option
  useEffect(() => {
    const firstFrameOptionIndex = frames.findIndex((option) => option.productId > 0);
    if (firstFrameOptionIndex >= -1) {
      selectFrame(frames[firstFrameOptionIndex], firstFrameOptionIndex);
    }
  }, []);

  return (
    <div className={styles.frameSelector}>
      <ProductCarousel forceShowArrows>
        {frames.map((frame, index) => {
          return (
            <div
              key={`fr${index}`}
              className={cn(styles.frame, {
                [styles.active]: activeFrameProductId === frame.productId,
              })}
              onClick={() => selectFrame(frame, index)}
            >
              {frame.thumbnailUrl && <img src={frame.thumbnailUrl} alt="" />}
              {!frame.thumbnailUrl && <span>{frame.name}</span>}
            </div>
          );
        })}
      </ProductCarousel>
      {Boolean(activeFrameProductId) && <div className={styles.frameTitle}>{frameTitle}</div>}
    </div>
  );
};

export default FrameSelector;
